export const AZURE_ARM_BASE_URL = 'https://management.azure.com';

export const AZURE_ARM_SCOPE = `${AZURE_ARM_BASE_URL}/user_impersonation`;

export const LANDING_ZONE_MANAGEMENT_GROUP_ID = 'alz-prod-landingzones';

export const AZURE_MANAGEMENT_GROUP_API_VERSION = '2020-05-01';

export const AZURE_SUBSCRIPTIONS_API_VERSION = '2022-12-01';

